import React from 'react';
import { Controller, useFieldArray } from 'react-hook-form';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import TextSnippetWrapper from 'components/TextSnippetWrapper';
import { MultiSelect } from 'primereact/multiselect';
import SingleChoice from 'shared/SingleChoiceComponent';
import MultipleChoice from 'shared/MultiChoiceComponent';
import TimeComponent from 'shared/TimeComponent';
import PhoneNumberComponent from 'shared/PhoneNumberComponent';
import LinkComponent from 'shared/LinkComponent';
import EmailComponent from 'shared/EmailComponent';
import TimezoneDatePicker from 'components/common/TimezoneDatePicker/TimezoneDatePicker';
import { useUserDetailsContext } from 'context/userDetailsContext';

export default function UnMappedFields({ control, field, setValue, errors }) {
  const userContext = useUserDetailsContext();
  const { fields } = useFieldArray({
    control,
    name: field,
  });

  const handleNumberFormat = (e, val, field) => {
    if (e.target.value) {
      if ((val.type === 'number' && /^[0-9-()./]*$/.test(e.target.value)) || val.type !== 'number') {
        field.onChange(e.target.value);
      }
    } else {
      setValue(field.name, '');
    }
  };

  return (
    <React.Fragment>
      {fields?.length > 0 ? (
        fields?.some(
          (val) =>
            (val?.value !== undefined && val?.value !== '' && (!Array.isArray(val.value) || val.value?.length > 0)) ||
            (val?.type === 'time' && val?.time !== undefined)
        ) ? (
          fields?.map((val, index) => {
            const shouldRender =
              (val?.value !== undefined && val?.value !== '' && (!Array.isArray(val.value) || val.value?.length > 0)) ||
              (val?.type === 'time' && val?.time !== undefined);
            const fieldName = `${field}[${index}].value`;

            return shouldRender ? (
              <React.Fragment key={val.id}>
                <div className="d-flex align-items-center py-2 flex-wrap">
                  <div className="col-12 col-lg-4 p-medium">
                    <div className="p-medium">{val.label}</div>
                  </div>
                  <div className="col-12 col-lg-8">
                    <>
                      {val.type === 'short' && (
                        <Controller
                          name={fieldName}
                          control={control}
                          render={({ field }) => (
                            <TextSnippetWrapper
                              type="text"
                              className="input-shadow w-100"
                              name={field.name}
                              value={field.value}
                              placeholder="Enter a text"
                              onChange={(e) => {
                                field.onChange(e.value);
                              }}
                              {...field}
                            />
                          )}
                        />
                      )}
                      {val.type === 'long' && (
                        <Controller
                          name={fieldName}
                          control={control}
                          render={({ field }) => (
                            <TextSnippetWrapper
                              type="textarea"
                              className="input-shadow w-100"
                              rows={5}
                              cols={30}
                              name={field.name}
                              placeholder="Enter a text"
                              value={field.value}
                              onChange={(e) => field.onChange(e.target.value)}
                            />
                          )}
                        />
                      )}
                      {val.type === 'number' && (
                        <Controller
                          name={fieldName}
                          control={control}
                          render={({ field }) => (
                            <InputText
                              className="input-shadow w-100"
                              id={field.name}
                              placeholder="Enter a number"
                              name={field.name}
                              value={field.value}
                              onChange={(e) => handleNumberFormat(e, val, field)}
                            />
                          )}
                        />
                      )}
                      {val.type === 'date' && (
                        <Controller
                          name={fieldName}
                          control={control}
                          render={({ field }) => (
                            <TimezoneDatePicker
                              id={field.name}
                              value={field.value || null}
                              onChange={(val) => field.onChange(val)}
                              placeholder="Select"
                              dateFormat={'mm/dd/yy'}
                              monthNavigator
                              yearNavigator
                              yearRange="1800:2250"
                              className="input-shadow w-100"
                              timezone={userContext?.userDetails?.timezone}
                              isEndOfDay={true}
                            />
                          )}
                        />
                      )}
                      {val.type === 'dropdown' && (
                        <Controller
                          name={fieldName}
                          control={control}
                          render={({ field }) => (
                            <Dropdown
                              className="w-100 input-shadow"
                              options={val.options}
                              name={field.name}
                              value={field.value}
                              onChange={(e) => field.onChange(e.value)}
                              filter
                              placeholder="Select"
                            />
                          )}
                        />
                      )}
                      {val.type === 'multiselect' && (
                        <Controller
                          name={fieldName}
                          control={control}
                          render={({ field }) => (
                            <MultiSelect
                              className="w-100 input-shadow"
                              options={val.options}
                              name={field.name}
                              value={field.value}
                              onChange={(e) => field.onChange(e.value)}
                              filter
                              placeholder="Select options"
                            />
                          )}
                        />
                      )}
                      {val.type === 'singlechoice' && (
                        <SingleChoice control={control} name={`${field}[${index}].value`} options={val.options} />
                      )}
                      {val.type === 'multiplechoice' && (
                        <MultipleChoice control={control} name={`${field}[${index}].value`} options={val.options} />
                      )}
                      {val.type === 'time' && <TimeComponent control={control} name={`${field}[${index}]`} />}
                      {val.type === 'phone' && <PhoneNumberComponent control={control} name={`${field}[${index}].value`} />}
                      {val.type === 'link' && <LinkComponent control={control} name={`${field}[${index}].value`} />}
                      {val.type === 'email' && <EmailComponent control={control} name={`${field}[${index}].value`} />}
                    </>
                  </div>
                </div>
              </React.Fragment>
            ) : null;
          })
        ) : (
          <div className="col-12 small">
            <i className="fas fa-info-circle mx-2 mt-1"></i>
            <span className="text-hint">No Answered Unmapped Fields Found.</span>
          </div>
        )
      ) : (
        <div className="col-12 small">
          <i className="fas fa-info-circle mx-2 mt-1"></i>
          <span className="text-hint">No Unmapped Fields Found.</span>
        </div>
      )}
    </React.Fragment>
  );
}
